// 在这里注册活动组件
export default {
  1251: () => import('./CouponPanel')
};
